import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { LOCATION_CONTROLER_URL } from "api/Service";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useUpdateLocation = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");
  const handleNetworkError = useHandleNetworkError(
    "Error while updating location"
  );

  return useMutation({
    mutationFn: async ({ id, ...locationData }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.put(
        `${tenantVal}${LOCATION_CONTROLER_URL}/${id}`,
        locationData,
        { headers: { "Content-Type": "application/json" } }
      );

      return response.data;
    },
    onSuccess: async () => {
      toast.success("Location updated successfully");
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["locationsAll"] }),
        queryClient.invalidateQueries({ queryKey: ["locationsActive"] }),
      ]);
    },
    onError: handleNetworkError,
  });
};
